import { CodeExecutionEngine } from '../app/core/models/execution.model';

export const environment = {
  production: false,
  hostname: 'chat.stg.crewdle.ai',
  firebase: {
    apiKey: 'AIzaSyDHDgmA574NVeMWV9SpW-q4QQMjkANuueg',
    authDomain: 'auth.stg.crewdle.ai',
    databaseURL: 'https://crewdle-sdk-stg-default-rtdb.firebaseio.com',
    projectId: 'crewdle-sdk-stg',
    storageBucket: 'crewdle-sdk-stg.firebasestorage.app',
    messagingSenderId: '519415702791',
    appId: '1:519415702791:web:5dd39042f881cfde3251a2',
    measurementId: 'G-65GE57FYE4',
  },
  functionsRegion: 'northamerica-northeast1',
  // App Check disabled on staging (no reCAPTCHA Enterprise key) - see environment.prod.ts.
  appCheckSiteKey: '',
  crewdleApiUrl: 'https://api.stg.crewdle.ai',
  integrationsApiUrl: 'https://api.stg.crewdle.ai',
  codeExecutionEngine: 'pyodide' as CodeExecutionEngine,
  adminConsoleUrl: 'https://admin.stg.crewdle.ai',
  authBaseUrl: 'https://auth.stg.crewdle.ai',
  websocketUrl: 'wss://api.stg.crewdle.ai/ws',
  mcpUrl: 'https://mcp.stg.crewdle.ai',
  titleGenerationModel: 'gpt-5-mini',
  folderKnowledge: {
    // Kept in sync with the durable Functions staging limit.
    maxUploadBytes: 10 * 1024 * 1024,
  },
};
